export default class MechrailOverview {
    constructor() {
        this.el = document.querySelector('.mechrailOverview');

        if (this.el) {
            this.infoBoxes = this.el.querySelectorAll('.mechrailOverviewInfoHolder');
            this.bindEvents();
        }
    }

    bindEvents() {
        for (let i = 0; i < this.infoBoxes.length; i++) {
            const box = this.infoBoxes[i];
            const button = box.querySelector('.mechrailOverviewButton');
            button.addEventListener('click', () => this.toggleInfoBox(box));
        }
    }

    toggleInfoBox(box) {
        box.classList.toggle('isActive');
        if (box.classList.contains('isActive')) {
            this.closeOtherBoxes(box);
        }
    }

    closeOtherBoxes(box) {
        for (let i = 0; i < this.infoBoxes.length; i++) {
            if (this.infoBoxes[i] !== box) {
                this.infoBoxes[i].classList.remove('isActive');
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/mechrailOverview/mechrailOverview.js